import { render, staticRenderFns } from "./FirmwareMgr.vue?vue&type=template&id=bb84cb2e&scoped=true"
import script from "./FirmwareMgr.vue?vue&type=script&lang=js"
export * from "./FirmwareMgr.vue?vue&type=script&lang=js"
import style0 from "./FirmwareMgr.vue?vue&type=style&index=0&id=bb84cb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb84cb2e",
  null
  
)

export default component.exports